import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@beyou/environments/environment';
import { BaseApiService } from '../base-api.service';

/** Lowercase ISO 3166-1 alpha-2 code to the country's name in the admin's content language. */
export type CountryNames = Record<string, string>;

@Injectable({
  providedIn: 'root',
})
export class CountriesApiService extends BaseApiService {
  private readonly baseUrl = `${environment.adminApiBaseUrl}/countries`;

  constructor(http: HttpClient) {
    super(http);
  }

  /** The countries an accent can be created for; only used while creating one. */
  public async getCountries(): Promise<CountryNames> {
    return await firstValueFrom(this.http.get<CountryNames>(this.baseUrl));
  }
}
